import type { FC } from "react"

import { GL_TRANSACTION_DIALOG_CONFIRM_LABELS } from "../../constants"
import { type GlTransactionDialogMode } from "../../types/dialog"

import { Button } from "@/components/common/Button"

interface EditGlTransactionDialogActionsProps {
  mode: GlTransactionDialogMode
  canConfirm: boolean
  isConfirming: boolean
  onClose: () => void
  onDirtyClose: () => void
  onAction: () => void
}

export const EditGlTransactionDialogActions: FC<EditGlTransactionDialogActionsProps> = ({
  mode,
  canConfirm,
  isConfirming,
  onClose,
  onDirtyClose,
  onAction,
}) => {
  if (mode === "view") {
    return (
      <Button appearance='contained' onClick={onClose} data-testid='gl-transaction.edit-dialog.close-button'>
        {GL_TRANSACTION_DIALOG_CONFIRM_LABELS.view}
      </Button>
    )
  }

  const isEditMode = mode === "edit"

  return (
    <>
      <Button
        appearance='outlined'
        onClick={isEditMode ? onDirtyClose : onClose}
        data-testid='gl-transaction.edit-dialog.cancel-button'
      >
        Cancel
      </Button>
      <Button
        type={isEditMode ? "submit" : "button"}
        appearance='contained'
        onClick={isEditMode ? undefined : onAction}
        disabled={isConfirming || !canConfirm}
        data-testid={`gl-transaction.edit-dialog.${isEditMode ? "save" : mode}-button`}
      >
        {GL_TRANSACTION_DIALOG_CONFIRM_LABELS[mode]}
      </Button>
    </>
  )
}
